module.exports = __webpack_public_path__ + "img/电信.0ea360af.png";